// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bTjq","signatureBlock":"Footer_signatureBlock__10J-b","signature":"Footer_signature__15zAB"};